import config from '../../config';
import { planFeature } from '../../services/SandboxService';
import { connectionState } from './connections';

/**
 * Which model keys Flow's assistant can use for this person (sandbox-first, docs/SANDBOX_FIRST.md), shared by
 * Features › Chat, the first-run setup and Settings:
 * - the organization's models need the deployment to provide them (`config.chatOrgModels`) and the person's plan to
 *   include them (`plan.features.chatOrgModels`, unknown counts as included);
 * - their own key needs the plan to include it (`plan.features.chatOwnKey`, unknown counts as included; a BFF that
 *   cannot keep keys says so itself, see ModelKeyForm).
 * - the AI Foundry connection does not decide the models: off, the organization's models stay selectable (it only
 *   brings AI Foundry's playbooks and tools; without it Chat uses Flow's default playbook).
 * Each comes with a one-line note for when it is not available.
 */
export function modelChoices(sandbox) {
  const planName = sandbox?.plan?.name;
  const notInPlan = planName ? `Not in your ${planName} plan.` : 'Not in your plan.';
  const orgInPlan = planFeature(sandbox, 'chatOrgModels') !== false;
  const ownInPlan = planFeature(sandbox, 'chatOwnKey') !== false;
  const orgProvided = Boolean(config.chatOrgModels);
  const foundry = connectionState(sandbox, 'aiFoundry');
  const foundryOff = foundry === 'org-off' || foundry === 'not-in-plan';
  return {
    org: {
      available: orgProvided && orgInPlan,
      inPlan: orgInPlan,
      note: !orgInPlan ? notInPlan
        : !orgProvided ? 'Not available: ask your admin to connect Flow to AI Foundry.'
          : foundryOff ? "Available. Without the AI Foundry connection, Chat uses Flow's default playbook."
            : 'Available: Flow is connected to AI Foundry',
    },
    own: { available: ownInPlan, inPlan: ownInPlan, note: ownInPlan ? '' : notInPlan },
  };
}
